// LIBRERIE
import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef } from "react";

// HOOKS
import useInViewAnimation from "../../hooks/utilityStyle/useInViewAnimation";

const Presentation: React.FC = () => {

    const { t } = useTranslation();

    const [pageReady, setPageReady] = useState(false);
    useEffect(() => {
        // Questo set time out è divuto al video che falsa lo posizione degli elemnti nel DOM finche non carica
        const timer = setTimeout(() => { 
            setPageReady(true);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    const ref1 = useRef<HTMLHeadingElement>(null);
    const ref2 = useRef<HTMLParagraphElement>(null);
    const allRefs: React.RefObject<HTMLHeadingElement | HTMLParagraphElement | null>[] = [ref1, ref2];
    useInViewAnimation({animationElementsRef: allRefs, animationClass: 'fade-in-left', pageReady: pageReady});

    return (
        <section id="presentation" className="space-ptb">
            <div className="container-fluid w-special">
                <h2 className="mb-4 text-center" dangerouslySetInnerHTML={{ __html: t("homePage.presentation.title") as string }}></h2>
                <div className="row mb-5 align-items-center">
                    <div className="col-12 col-lg-6">
                        <p dangerouslySetInnerHTML={{ __html: t("homePage.presentation.para1") as string }}></p>
                        <p dangerouslySetInnerHTML={{ __html: t("homePage.presentation.para2") as string }}></p>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="img-wrapper" ref={ref1}>
                            <img src="/assets/images/inHome/andrea1.jpg" alt={t("homePage.presentation.altImg1") as string} className="img-fluid" />
                        </div>
                    </div>
                </div>
                <div className="row flex-lg-row-reverse align-items-center">
                    <div className="col-12 col-lg-6">
                        <p dangerouslySetInnerHTML={{ __html: t("homePage.presentation.para3") as string }}></p>
                        <p dangerouslySetInnerHTML={{ __html: t("homePage.presentation.para4") as string }}></p>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="img-wrapper" ref={ref2}>
                            <img src="/assets/images/inHome/certosa.webp" alt={t("homePage.presentation.altImg2") as string} className="img-fluid" />
                        </div>
                    </div>
                </div>        
            </div>
        </section>
    )
}
export default Presentation;